import React, { useEffect, useState, useCallback } from "react";
// import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { viewPropertyList } from "../../Redux/Actions/propertyActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { columnsPropertiesResale } from "../../Global Functions/columnsAntd";
import { Table } from "antd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";
import BookingSourceDropdown from "./dropDown";
import toast from "react-hot-toast";

const ListProperties = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [businessType, setBusinessType] = useState("resale");

  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { properties, loading } = useSelector((state) => state.properties || {});
  const propStatus = enumsData?.data?.PropertyStatus;

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    async (page, limit, showLoader = false) => {
      if (!propStatus) return;

      const payload = {
        status: propStatus,
        page,
        limit,
        is_deleted: false,
        business_type: businessType || "resale",
        filter: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      try {
        await dispatch(viewPropertyList(payload, showLoader));
        if (!showLoader) {
          // toast.success("Properties list refreshed");
        }
      } catch {
        if (!showLoader) {
          toast.error("Failed to refresh properties list");
        }
      }
    },
    [dispatch, debouncedSearch, propStatus, dateRange, businessType]
  );

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (properties?.total) {
      setPagination((prev) => ({ ...prev, total: properties.total }));
    }
  }, [properties]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPagination((prev) => ({ ...prev, current: 1 }));
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDetails(pagination.current, pagination.pageSize, false);
    }, 1800000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <div className="bookings_table">
        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading={`${businessType ? businessType.charAt(0).toUpperCase() + businessType.slice(1) : "All"} Properties List`}
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
            />
          </div>

          <div
            style={{
              position: "static",
              marginTop: "-69.6px",
              marginLeft: "87.5%",
              marginBottom: "24px",
            }}
          >
            <BookingSourceDropdown
              value={businessType}
              onChange={(e) => {
                setBusinessType(e.target.value);
                setPagination((prev) => ({ ...prev, current: 1 }));
              }}
            />
          </div>

          <div style={{ padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(properties?.data) ? properties.data : []}
              virtual
              scroll={{ x: 1700, y: 500 }}
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsPropertiesResale(businessType)}
            />
          </div>
        </div>
      </div>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListProperties;